module.exports = __webpack_public_path__ + "static/idia-logo-9d45e6bd822001e97164b5d3b607c8d3.svg";